import Styleguide from "@store/Framework/Types/Styleguide";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { infoProps } from "@store/Themes/common/props/info";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
                /* Store Custom Code - Start */
                &::after {
                    border-color: ${getColor("neutral.light")} transparent transparent transparent;
                }
                /* Store Custom Code - End */
            `,
            /* Store Custom Code - Start */
            tooltipBody: css`
                background-color: ${getColor("neutral.light")};
                color: ${getColor("text")};
            `,
            /* Store Custom Code - End */
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
